export default {
	methods: {
		successModal(title, message) {
			this.$root.$bvToast.toast(message, {
				title: title,
				solid: true,
				autoHideDelay: 5000,
				headerClass: "toast-headerclass",
				bodyClass: "toast-bodyclass",
				toastClass: "",
			});
			this.toasttext = "";
		},
	},
};